import { Stack } from 'expo-router';

function PlaidLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}

export default PlaidLayout;
